import {
    SteelSingleSwingDoorCode,
    SteelDoubleSwingDoorsCode,
    SteelSingleSlidingDoorCode,
    SteelDoubleSlidingDoorsCode,
    SteelMultiSlidingDoorsCode,
    SteelFoldingDoorsCode,
    SteelArchSingleSwingDoorCode,
    SteelArchDoubleSwingDoorsCode,
} from "../../../../constants";
import { CGF300NoDoorsConfigs } from "./cgf300/mounts-no-door.config";
import { CGF300SlidingDoorsConfigs } from "./cgf300/mounts-sliding-door.config";
import { CGF300SwingDoorsConfigs } from "./cgf300/mounts-swing-door.config";

import { CGF350NoDoorsConfigs } from "./cgf350/mounts-no-door.config";
import { CGF350SlidingDoorsConfigs } from "./cgf350/mounts-sliding-door.config";
import { CGF350SwingDoorsConfigs } from "./cgf350/mounts-swing-door.config";

import { CGF400NoDoorsConfigs } from "./cgf400/mounts-no-door.config";
import { CGF400SlidingDoorsConfigs } from "./cgf400/mounts-sliding-door.config";
import { CGF400SwingDoorsConfigs } from "./cgf400/mounts-swing-door.config";

import { CGS200NoDoorsConfigs } from "./cgs200/mounts-no-door.config";
import { CGS200SlidingDoorsConfigs } from "./cgs200/mounts-sliding-door.config";
import { CGS200SwingDoorsConfigs } from "./cgs200/mounts-swing-door.config";

import { KompasNoDoorsConfigs } from "./kompas/mounts-no-door.config";
import { KompasSlidingDoorsConfigs } from "./kompas/mounts-sliding-door.config";
import { KompasSwingDoorsConfigs } from "./kompas/mounts-swing-door.config";
import { KompasCGFDoorsConfigs } from "./kompas/mounts-cgf-door.config";

import { RomanoAnyDoorsConfigs } from "./romano/mounts-any-door.config";
import { RomanoNoDoorsConfigs } from "./romano/mounts-no-door.config";
import { TreviAnyDoorsConfigs } from "./trevi/mounts-any-door.config";
import { TreviNoDoorsConfigs } from "./trevi/mounts-no-door.config";
import { Partition } from "@/app/domain";

export const CGF300PerimeterConfigs = {
    noDoors: CGF300NoDoorsConfigs,
    slidingDoors: CGF300SlidingDoorsConfigs,
    swingDoors: CGF300SwingDoorsConfigs,
};

export const CGF350PerimeterConfigs = {
    noDoors: CGF350NoDoorsConfigs,
    slidingDoors: CGF350SlidingDoorsConfigs,
    swingDoors: CGF350SwingDoorsConfigs,
};

export const CGF400PerimeterConfigs = {
    noDoors: CGF400NoDoorsConfigs,
    slidingDoors: CGF400SlidingDoorsConfigs,
    swingDoors: CGF400SwingDoorsConfigs,
};

export const CGS200PerimeterConfigs = {
    noDoors: CGS200NoDoorsConfigs,
    slidingDoors: CGS200SlidingDoorsConfigs,
    swingDoors: CGS200SwingDoorsConfigs,
};

export const KompasPerimeterConfigs = {
    noDoors: KompasNoDoorsConfigs,
    slidingDoors: KompasSlidingDoorsConfigs,
    cgfDoors: KompasCGFDoorsConfigs,
    swingDoors: KompasSwingDoorsConfigs,
};

export const RomanoPerimeterConfigs = {
    steelSingleSwing: (partition: Partition) =>
        RomanoAnyDoorsConfigs(partition, SteelSingleSwingDoorCode),
    steelDoubleSwing: (partition: Partition) =>
        RomanoAnyDoorsConfigs(partition, SteelDoubleSwingDoorsCode),
    steelSingleSliding: (partition: Partition) =>
        RomanoAnyDoorsConfigs(partition, SteelSingleSlidingDoorCode),
    steelDoubleSliding: (partition: Partition) =>
        RomanoAnyDoorsConfigs(partition, SteelDoubleSlidingDoorsCode),
    steelMultiSliding: (partition: Partition) =>
        RomanoAnyDoorsConfigs(partition, SteelMultiSlidingDoorsCode),
    steelFolding: (partition: Partition) =>
        RomanoAnyDoorsConfigs(partition, SteelFoldingDoorsCode),
    steelArchSingleSwing: (partition: Partition) =>
        RomanoAnyDoorsConfigs(partition, SteelArchSingleSwingDoorCode),
    steelArchDoubleSwing: (partition: Partition) =>
        RomanoAnyDoorsConfigs(partition, SteelArchDoubleSwingDoorsCode),
    noDoors: RomanoNoDoorsConfigs,
};

export const TreviPerimeterConfigs = {
    steelSingleSwing: (partition: Partition) =>
        TreviAnyDoorsConfigs(partition, SteelSingleSwingDoorCode),
    steelDoubleSwing: (partition: Partition) =>
        TreviAnyDoorsConfigs(partition, SteelDoubleSwingDoorsCode),
    steelSingleSliding: (partition: Partition) =>
        TreviAnyDoorsConfigs(partition, SteelSingleSlidingDoorCode),
    steelDoubleSliding: (partition: Partition) =>
        TreviAnyDoorsConfigs(partition, SteelDoubleSlidingDoorsCode),
    steelMultiSliding: (partition: Partition) =>
        TreviAnyDoorsConfigs(partition, SteelMultiSlidingDoorsCode),
    steelFolding: (partition: Partition) =>
        TreviAnyDoorsConfigs(partition, SteelFoldingDoorsCode),
    steelArchSingleSwing: (partition: Partition) =>
        TreviAnyDoorsConfigs(partition, SteelArchSingleSwingDoorCode),
    steelArchDoubleSwing: (partition: Partition) =>
        TreviAnyDoorsConfigs(partition, SteelArchDoubleSwingDoorsCode),
    noDoors: TreviNoDoorsConfigs,
};
